import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Spin,
  Table
} from "antd";
import React, {
  forwardRef,
  useState,
  useImperativeHandle,
  useRef,
  useEffect,
} from "react";
import { EditOutlined, BankOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import CustomUploadNewBank from "@/hocComponents/customUploadNewBank";
const EditModal = forwardRef((props, ref) => {
  const glChartNameIdRef = useRef(null);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [bankId, setBankId] = useState(null);
  const [initLoading, setInitLoading] = useState(false);
  const { onSuccess } = props;
  const bankBalanceNewIdRef = useRef(null);
  const [filePaths, setFilePaths] = useState([]);
  const [statementFiles, setStatementFiles] = useState([]);
  const [previewIndex, setPreviewIndex] = useState(-1);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [allFilesState, setAllFilesState] = useState([]);
  const activeValue = Form.useWatch("active", form);
  const isActive = activeValue !== "0";
  const uploadRef = useRef(null);
  const [bankTableData, setBankTableData] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const { amountToDollarBracketFn } = commonFn;
  const bankFieldMap = {
    ownerId: "ownerId",
    name: "name",
    street: "street",
    city: "city",
    state: "state",
    zip: "zip",
    phone: "phone",
    transitCp: "transitCp",
    cpAcct: "cpAcct",
    managementCompanyId: "managementCompanyId",
    trustId: "trustId",
    bank: "bank",
    remark: "remark",
    lastCheckNo: "lastCheckNo",
    glAcct: "glAcct",
    isNeedRec: "isNeedRec",
    positivePay: "positivePay",
    active: "active",
    baiFile: "baiFile",
    balance: "balance",
  };

  const syncFileList = (files = []) => {
    setFilePaths(files);
  };

  const getOwnerIdList = async () => {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList(response?.data || []);
  };

  useEffect(() => {
    setStatementFiles(filePaths);
    setAllFilesState(filePaths);
    setPreviewIndex(filePaths.length ? 0 : -1);
    form.setFieldsValue({
      fileList: filePaths,
      bankFile: filePaths,
    });
  }, [filePaths, form]);
useEffect(() => {
  if (filePaths.length > 0) {
    uploadRef.current?.initUpdateList(filePaths);
  }
}, [filePaths]);
  useImperativeHandle(ref, () => ({
    open: async (record) => {
      const id = record?.bankId;
      const bankBalanceNewId = record?.bankBalanceNewId;
      bankBalanceNewIdRef.current = bankBalanceNewId;
      setVisible(true);
      setBankId(id);
      setInitLoading(true);
      await getOwnerIdList()

      // 清空旧数据
      form.resetFields();
      setStatementFiles([]);
      setAllFilesState([]);
      setPreviewIndex(-1);
      setFilePaths([]);
      setBankTableData([]); 
      try {
        if (!id) return;
        const trustId = await loadBankDetail(id, bankBalanceNewId);
        // await loadBankDetail(id, bankBalanceNewId);
        if (trustId) {
        await fetchBankDataByTrustId(trustId);
      }
        const files = await loadAllBankFiles(id);
        const allFiles = [...files.bankBalanceFile];
        syncFileList(allFiles);
        setTimeout(() => {
  if (allFiles.length > 0) {
    uploadRef.current?.initUpdateList(allFiles);
  }
}, 0);
      } finally {
        setInitLoading(false);
      }
    },
  }));

  const loadBankDetail = async (id, bankBalanceNewId) => {
    if (!id) return;

    try {
      setLoading(true);
      const res = await http.get(api.getBankById, {
        params: { bankId: id, bankBalanceNewId },
      });
      const data = res?.data;
      if (!data) return;

      if (data.managementCompanyId && data.companyName) {
        companySelect.setOptions([
          {
            value: data.managementCompanyId,
            label: data.companyName,
          },
        ]);
      }

      if (data.trustId && data.trustName) {
        trustSelect.setOptions([
          {
            value: data.trustId,
            label: data.trustName,
          },
        ]);
      }

      if (data.glAcct && data.glAcctTitle) {
        glSelect.setOptions([
          {
            value: data.glAcct,
            label: data.glAcctTitle,
          },
        ]);
      }
      const patch = {};
      Object.keys(bankFieldMap).forEach((key) => {
        const formKey = bankFieldMap[key];
        let value = data[key] ?? "";

        if (
          formKey === "isNeedRec" ||
          formKey === "positivePay" ||
          formKey === "active" ||
          formKey === "baiFile"
        ) {
          value = value === 0 || value === 1 ? String(value) : "";
        }
        if (formKey === "managementCompanyId") value = data[key] ?? undefined;
        if (formKey === "trustId") value = data[key] ?? undefined;
        if (formKey === "glAcct") value = data[key] ?? undefined;

        patch[formKey] = value;
      });

      form.setFieldsValue(patch);
      if (data.glChartNameId) glChartNameIdRef.current = data.glChartNameId;
       return data.trustId;
    } catch (e) {
      console.error(e);
      message.error("Failed to load bank detail");
    } finally {
      setLoading(false);
    }
  };

  const loadAllBankFiles = async (bankId) => {
    if (!bankId) return { bankBalance: [], bankStatement: [] };

    try {
      const types = ["bankFile"];

      const results = await Promise.all(
        types.map((type) =>
          http.get(api.getBankByFile, {
            params: { foreignId: bankId, type },
          }),
        ),
      );

      const mapFiles = (files, type) =>
        (files || []).map((f) => ({
          id: f.id,
          uid: `${type}-${f.id}`,
          type,
          path: f.path,
          fileName: f.fileDateName || f.fileName,
          name: f.fileDateName || f.fileName,
          status: f.status ?? 0,
          url: f.url,
          allPath: f.url,
          _fromServer: true,
        }));

      return {
        bankBalanceFile: mapFiles(results[0]?.data, "bankFile"),
      };
    } catch (e) {
      console.error(e);
      message.error("Failed to load bank files");
      return { bankBalanceFile: [] };
    }
  };

  function useLazySelect(apiUrl, cacheKey, mapper, enableCache = true) {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    const load = async (params = {}, force = false) => {
      if (options.length && enableCache && !force) return;

      setLoading(true);
      const res = Object.keys(params).length
        ? await http.get(apiUrl, { params })
        : await http.get(apiUrl);

      setOptions(mapper(res?.data || []));
      setLoading(false);
    };

    return { options, loading, load, setOptions };
  }
  const trustSelect = useLazySelect(api.getTrustDictList, "trust", (data) =>
    data.map((d) => ({
      label: d.trustNameTitle,
      value: d.trustId,
      glChartNameId: d.glChartNameId,
    })),
  );

  const stateSelect = useLazySelect(api.getStateDictList, "state", (data) =>
  Object.entries(data || {}).map(([key, label]) => ({
    label,   
    value: key, 
  })),
);
  const glSelect = useLazySelect(
    api.getBankGLById,
    "glacct",
    (data) =>
      data.map((d) => ({
        label: d.glAcctTitle,
        // value: d.glChartId,
        value: d.glAcct,
      })),
    false,
  );
  const companySelect = useLazySelect(
    api.getCompanyDictList,
    "company",
    (data) =>
      data.map((d) => ({
        label: d.companyNameCode,
        value: d.companyId,
      })),
  );

  const onTrustChange = async (trustId) => {
    const trust = trustSelect.options.find((item) => item.value === trustId);
    if (!trust) return;
    await fetchBankDataByTrustId(trustId);
    const glId = Number(trust.glChartNameId);
    await glSelect.load({ glChartNameId: glId });
  };
  const fetchBankDataByTrustId = async (trustId) => {
  if (!trustId) {
    setBankTableData([]);
    return;
  }

  setTableLoading(true);
  try {
    const res = await http.get(api.getBankByTrust, { params: { trustId } });
    if (res?.code === "1" && res?.data) {
      // inactive 排序
  const sorted = [...res.data].sort(
    (a, b) => (b.bankActive ?? 0) - (a.bankActive ?? 0)
  );
  setBankTableData(sorted);

      // setBankTableData(res.data);
    } else {
      setBankTableData([]);
    }
  } catch (error) {
    console.error("Failed to fetch bank data:", error);
    setBankTableData([]);
  } finally {
    setTableLoading(false);
  }
};
  const uploadByBankApi = async (file, fieldType) => {
    const formData = new FormData();
    formData.append("files", file.originFileObj);
    formData.append("type", fieldType);

    const res = await http.post(api.getBankUpload, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.code === "1") return res.data[0];
    throw new Error(res.msg || "Upload failed");
  };

  const addUploadFile = async (file) => {
    const params = {
      foreignId: bankId,
      type: file.type,
      path: file.path,
      fileName: file.fileName,
      status: file.status ?? 1,
    };

    const res = await http.post(api.getAddUploadFile, params);
    if (res?.code !== "1") {
      throw new Error(res?.msg || "Upload file save failed");
    }
  };

  const addOldFn = async (files) => {
    setBtnDisabled(true);
    try {
      const currentFile = files?.[files.length - 1];
      if (!currentFile?.originFileObj) {
        return { flag: false };
      }

      const uploadedFile = await uploadByBankApi(currentFile, "bankFile");
      const normalizedFile = {
        ...uploadedFile,
        uid: uploadedFile?.customId || currentFile.uid,
        type: "bankFile",
        name:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        fileName:
          uploadedFile?.fileDateName ||
          uploadedFile?.fileName ||
          currentFile.name,
        allPath:
          uploadedFile?.url ||
          uploadedFile?.allPath ||
          (currentFile.originFileObj &&
            URL.createObjectURL(currentFile.originFileObj)),
        originFileObj: currentFile.originFileObj,
        size: currentFile.size,
      };

      return {
        flag: true,
        fileData: normalizedFile,
      };
    } catch (error) {
      console.error(error);
      message.error(error?.message || "Upload failed");
      return { flag: false };
    } finally {
      setBtnDisabled(false);
    }
  };

  const deleteOldFn = async (file) => {
    return true;
  };

  const deleteBase64FileFn = async (file) => {
    const list = filePaths.filter((item) =>
      file?.uuid ? item.uuid !== file.uuid : item.uid !== file.uid,
    );
    return list;
  };

  const onFinish = async () => {
    setLoading(true);
    try {
      const values = await form.validateFields();
      const fileList = form.getFieldValue("fileList") || [];

      const newFiles = fileList.filter((f) => !f._fromServer);
      if (newFiles.length > 0) {
        for (const f of newFiles) {
          await addUploadFile(f);
        }
      }
      const params = {
        bankId: bankId,
        bankBalanceNewId: bankBalanceNewIdRef.current,
        ownerId: values?.ownerId || undefined,
        name: values?.name || undefined,
        street: values?.street || undefined,
        city: values?.city || undefined,
        state: values?.state || undefined,
        zip: values?.zip || undefined,
        phone: values?.phone || undefined,
        transitCp: values?.transitCp || undefined,
        cpAcct: values?.cpAcct || undefined,
        managementCompanyId: values?.managementCompanyId || undefined,
        trustId: values?.trustId || undefined,
        bank: values?.bank || undefined,
        remark: values?.remark || undefined,
        lastCheckNo: values?.lastCheckNo || undefined,
        glAcct: values?.glAcct || undefined,
        isNeedRec: values?.isNeedRec || undefined,
        positivePay: values?.positivePay || undefined,
        baiFile: values?.baiFile || undefined,
        balance: values?.balance || undefined,
        active: values?.active || undefined,
        // fileList: fileList.map(({ uid, ...rest }) => rest),
      };

      const res = await http.post(api.getBankEdit, params);

      if (res?.code === "1") {
        message.success("Bank Updated Successfully.");
        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(res?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error(err.message || "Request failed, please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            EDIT BANK
          </Typography.Title>
        </Flex>
      }
      width="95%"
      centered
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
        setStatementFiles([]);
        setAllFilesState([]);
        setPreviewIndex(-1);
        syncFileList([]);
      }}
      maskClosable={false}
      footer={
          <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
            syncFileList([]);
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>
      }
    >
      <Spin spinning={initLoading}>
        <Flex justify="space-between" align="flex-start">
          <div className="model_top" style={{ width: "100%" }}>
            <div>
              <Form
                form={form}
                name="createBankForm"
                layout="horizontal"
                labelCol={{ style: { width: "200px" } }}
                wrapperCol={{ style: { flex: 1 } }}
                onFinish={onFinish}
              >
                <Flex align="flex-start" justify="space-between" gap={16}>
                  {/* ========== 左侧：Bank Detail ========== */}
                  <div style={{ flex: "0 0 26%" }}>
                    <div className="modal-section-title">
                      <BankOutlined /> Bank Detail
                    </div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                          <Form.Item label="Bank Account Owner" name="ownerId" style={{ marginBottom: 0 }}>
                            <Select
                              showSearch
                              allowClear
                              placeholder="Select a type"
                              optionFilterProp="label"
                              filterOption={(input, option) =>
                                (option?.titleName ?? "")
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              fieldNames={{
                                label: 'titleName',
                                value: 'ownerId',
                              }}
                              options={ownerList}
                            />
                          </Form.Item>

                          <Form.Item
                            name="managementCompanyId"
                            label="Account Managing Company"
                            rules={[{ required: isActive }]}
                              style={{ marginBottom: 0 }}
                          >
                            <Select
                            showSearch
                            optionFilterProp="label"
                              placeholder="Select Company"
                              loading={companySelect.loading}
                              options={companySelect.options}
                              onDropdownVisibleChange={async (open) => {
                                if (open) await companySelect.load({}, true); // force = true
                              }}
                            />
                          </Form.Item>

                        <Form.Item name="remark" label="Remark"   style={{ marginBottom: 0 }}>
                          <Input placeholder="Remark" />
                        </Form.Item> 

                           <Form.Item
                      name="trustId"
                      label="Beneficiary/Entity"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                       showSearch
                       optionFilterProp="label"
                        placeholder="Select Trust"
                        loading={trustSelect.loading}
                        options={trustSelect.options}
                        onDropdownVisibleChange={async (open) => {
                          if (open) await trustSelect.load({}, true); // force = true
                        }}
                        onChange={onTrustChange}
                      />
                    </Form.Item>
                    <Form.Item
                      name="name"
                      label="Bank Name"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Bank Name" />
                    </Form.Item>

                    <Form.Item name="street" label="Street"   style={{ marginBottom: 0 }}>
                      <Input placeholder="Street" />
                    </Form.Item>

                    <Form.Item name="city" label="City"   style={{ marginBottom: 0 }}>
                      <Input placeholder="City" />
                    </Form.Item>

                    <Form.Item
                      name="state"
                      label="State"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                       showSearch
                       optionFilterProp="label"
                        placeholder="Select State"
                        loading={stateSelect.loading}
                        options={stateSelect.options}
                        onDropdownVisibleChange={(open) => {
                          if (open) stateSelect.load();
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      name="zip"
                      label="Zip"
                      rules={[{required: isActive, message: 'Zip is required!' },
                      { validator: commonFn.zipValidator }]}
                      style={{ marginBottom: 0 }}
                      // rules={[{ required: isActive }]}
                    >
                      <Input placeholder="Zip" />
                    </Form.Item>

                    <Form.Item
                      name="phone"
                      label="Phone"
                      // rules={[{ required: isActive }]}
                       rules={[
                      { required: isActive, message: 'Phone is required!' },
                      { validator: commonFn.usPhoneValidator }
                       ]}  style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Phone" />
                    </Form.Item>
                    <Form.Item
                      name="transitCp"
                      label="Routing"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Routing" />
                    </Form.Item>

                    <Form.Item
                      name="cpAcct"
                      label="Account#"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Account#" />
                    </Form.Item> 

                    <Form.Item
                      name="lastCheckNo"
                      label="Starting Check #"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="1st Check #" />
                    </Form.Item>
                     <Form.Item
                      name="bank"
                      label="PPM Bank Number"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Input placeholder="Bank" />
                    </Form.Item>

                    <Form.Item
                      name="glAcct"
                      label="Cash GL"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                       showSearch
                       optionFilterProp="label"
                        placeholder="Select GL"
                        loading={glSelect.loading}
                        options={glSelect.options}
                        onDropdownVisibleChange={async (open) => {
                          if (open && glChartNameIdRef.current) {
                            await glSelect.load({
                              glChartNameId: Number(glChartNameIdRef.current),
                            });
                          }
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      name="active"
                      label="Active"
                      rules={[{ required: true }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                        options={[
                          { value: "1", label: "Yes" },
                          { value: "0", label: "No" },
                        ]}
                      />
                    </Form.Item>

                    <Form.Item
                      name="isNeedRec"
                      label="Need Bank Reconciliation?"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                        options={[
                          { value: "1", label: "Yes" },
                          { value: "0", label: "No" },
                        ]}
                      />
                    </Form.Item>

                    <Form.Item
                      name="positivePay"
                      label="Positive Pay File"
                      rules={[{ required: isActive }]}
                        style={{ marginBottom: 0 }}
                    >
                      <Select
                        options={[
                          { value: "1", label: "Yes" },
                          { value: "0", label: "No" },
                        ]}
                      />
                    </Form.Item>

                    <Form.Item name="baiFile" label="Bai file"   style={{ marginBottom: 0 }}>
                      <Select
                        options={[
                          { value: "1", label: "Yes" },
                          { value: "0", label: "No" },
                        ]}
                      />
                    </Form.Item>
                    </div>  
               </div>
                  <div style={{ flex: "0 0 35%" }}>
                    {/* upload */}
                    <div
                      style={{
                        marginBottom: "16px",
                        fontWeight: "bold",
                        fontSize: "20px",
                      }}
                    >
                      Upload PDF image
                    </div>
                    <Form.Item
                      labelCol={{ span: 0 }}
                      wrapperCol={{ span: 24 }}
                      label={null}
                    >
                      <div>
                        <div className="uploadText">
                          Uploaded files only support JPG, PNG or PDF.
                        </div>
                        <div
                          style={{
                            marginTop: "20px",
                            display: "flex",
                            gap: 16,
                          }}
                        >
                          {/* Upload Bank Statement */}
                          <div style={{ flex: 1 }}>
                            <Form.Item name="bankFile" noStyle>
                              <div style={{ marginTop: "20px" }}>
                                <CustomUploadNewBank
                                ref={uploadRef}
                                  customConfig={{
                                    uploadButtonStyle: {
                                      top: "0",
                                    },
                                    pdfHeight: "62vh",
                                    fileFullName: "name",
                                    notMultiple: true,
                                    accept: ".jpg, .jpeg, .png, .pdf",
                                    status: "add",
                                    deleteOldFn: deleteOldFn,
                                    deleteBase64FileFn: deleteBase64FileFn,
                                    addOldFn: addOldFn,
                                  }}
                                  setFilePaths={syncFileList}
                                  filePaths={filePaths}
                                  setBtnDisabled={setBtnDisabled}
                                  btnDisabled={btnDisabled}
                                />
                              </div>
                            </Form.Item>
                          </div>
                          
                        </div>
                      </div>

                      <Form.Item name="fileList" hidden />
                    </Form.Item>
                  </div>

                  <div style={{ flex: "0 0 38%", overflow: 'auto' }}>
                    <div className="modal-section-title" style={{ marginBottom: "12px" }}>
                      Bank Information
                    </div>
                    <Table
                      dataSource={bankTableData}
                      loading={tableLoading}
                      size="small"
                      pagination={false}
                      scroll={{ x: true }}  
                      rowKey="bankId"
                      columns={[
                        {
                          title: "Company",
                          dataIndex: "company",
                          key: "company",
                          ellipsis: true,
                          render: (text) => text,
                        },
                        {
                          title: "Bank Name",
                          dataIndex: "bankName",
                          key: "bankName",
                          ellipsis: true,
                          render: (text) => text ,
                        },
                        {
                          title: "Account#",
                          dataIndex: "accountNumber",
                          key: "accountNumber",
                          ellipsis: true,
                          render: (text) => text ,
                        },
                        {
                          title: "PPM Bank",
                          dataIndex: "bank",
                          key: "bank",
                          render: (text) => text,
                        },
                        {
                          title: "Cash GL",
                          dataIndex: "cashGl",
                          key: "cashGl",
                          render: (text) => text ,
                        },
                        {
                          title: "Remark",
                          dataIndex: "remark",
                          key: "remark",
                          ellipsis: true,
                          render: (text) => text ,
                        },
                        {
                          title: "Balance",
                          dataIndex: "balance",
                          key: "balance",
                          width: 80,
                          // render: (text) => commonFn.amountToDollarBracketFn(text),
                           render: (text) =>
    text === null || text === undefined || text === "" || Number(text) === 0
      ? "$0"
      : commonFn.amountToDollarBracketFn(text),
                        },
                        {
                          title: "Bank Active",
                          dataIndex: "bankActive",
                          key: "bankActive",
                          width: 100,
                          render: (text) => text === 1 ? 'Active' : "Inactive" ,
                        },
                      ]}
                      locale={{
                        emptyText: tableLoading ? "Loading..." : "No data available",
                      }}
                      style={{ width: "100%" }}
                    />
                  </div>

                </Flex>
              </Form>
            </div>
          </div>
        </Flex>
      </Spin>
    </Modal>
  );
});

export default EditModal;
